import React, { useEffect, useState } from "react";
import SingleItem from "./SingleItem";
import Skeleton from "react-loading-skeleton";

const UpcomingNFT = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/user/nft/upcoming/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setLoading(false);
      });
  }, []);

    if (loading) {
      return (
        <section className="mobile-version">
          <div className="Mobile-version-slider">
            <Skeleton count={15} height={35} />
          </div>
        </section>
      );
    }

  return (
    <>
      <div className="tab-content" id="pills-tabContent">
        <div
          className="tab-pane fade show active"
          id="pills-top"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
          tabIndex="0"
        >
          <div className="d-flex gap-2 flex-column my-3" id="coinContainer">
           {data.length !== 0 ? (
              data.map((data, index) => {
                if (data) {
                  return (
                    <SingleItem
                      data={data}
                      key={data?._id}
                      index={index}
                    ></SingleItem>
                  );
                }
              })
            ) : (
                <div className="data-not-available">
                  Data not available
                </div>
            )}
          </div>
        </div> 
      </div>
    </>
  );
};

export default UpcomingNFT;
